import moment from "moment";
import axios from "../../helpers/httpClient";

export default {
    activeMessageCorrect: ({ commit, state }, mensaje) => {
        let uniqueMessage = moment().format("YYYYMMDDHHmmssSSS")
        commit('SET_MESSAGE_CORRECT', { mensaje: {
            ...state.mensaje,
            [uniqueMessage]: {
                type: 'correct',
                active: true,
                mensaje
            }
        }});
        window.scroll(0, 0)
    },
    activeMessageError: ({ commit, state }, mensaje) => {
        let uniqueMessage = moment().format("YYYYMMDDHHmmssSSS")
        commit('SET_MESSAGE_CORRECT', { mensaje: {
            ...state.mensaje,
            [uniqueMessage]: {
                type: 'error',
                active: true,
                mensaje
            }
        } });
        window.scroll(0, 0)

    },
    setMessage: ({ commit }, mensaje) => {
        commit('SET_MESSAGE_CORRECT', { mensaje })
    },
    tableSearchAction: ({ commit, state, dispatch }, arrayState) => {
        try {
            const { value, data } = arrayState
            const newArrayFilter = state[data.data].filter((filterData) => {
                for (let clave in value[0]) {
                    if (value[0][clave][1] === "text") {
                        if (!value[0][clave][2]) {
                            if (value[0][clave][0] !== "") {
                                if (value[0][clave][0].toLowerCase() !== String(filterData[clave]).substring(0, value[0][clave][0].length).toLowerCase()) {
                                    return
                                }
                            }
                        } else {
                            if (value[0][clave][0] !== "") {
                                if (value[0][clave][0].toLowerCase() !== String(value[0][clave][2](filterData[clave.substring(clave.length - 1, 0)])).substring(0, value[0][clave][0].length).toLowerCase()) {
                                    return
                                }
                            }
                        }
                    }
                }
                for (let clave in value[1]) {
                    if (value[1][clave][0] !== "") {
                        if (!value[1][clave][3]) {
                            if (value[1][clave][2] === "desde") {
                                if (Number(moment(value[1][clave][0], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm')) > Number(moment(filterData[clave.substring(clave.length - 1, 0)], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm'))) {
                                    return;
                                }
                            }
                            if (value[1][clave][2] === "hasta") {
                                if (Number(moment(value[1][clave][0], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm')) < Number(moment(filterData[clave.substring(clave.length - 1, 0)], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm'))) {
                                    return;
                                }
                            }
                        } else {
                            if (value[1][clave][2] === "desde") {
                                if (Number(moment(value[1][clave][0], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm')) > Number(moment(value[1][clave][3](filterData[clave.substring(clave.length - 2, 0)], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm')))) {
                                    return;
                                }
                            }
                            if (value[1][clave][2] === "hasta") {
                                if (Number(moment(value[1][clave][0], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm')) < Number(moment(value[1][clave][3](filterData[clave.substring(clave.length - 2, 0)], 'YYYY-MM-DD hh:mm a').format('YYYYMMDDHHmm')))) {
                                    return;
                                }
                            }
                        }
                    }
                }
                for (let clave in value[2]) {
                    if (value[2][clave][0] !== "") {
                        if (!value[2][clave][3]) {
                            if (value[2][clave][2] === "maximo") {
                                if (value[2][clave][0] < filterData[clave.substring(clave.length - 1, 0)]) {
                                    return;
                                }
                            }
                            if (value[2][clave][2] === "minimo") {
                                if (value[2][clave][0] > filterData[clave.substring(clave.length - 1, 0)]) {
                                    return;
                                }
                            }
                        } else {
                            if (value[2][clave][2] === "maximo") {
                                if (value[2][clave][0] < value[2][clave][3](filterData[clave.substring(clave.length - 2, 0)])) {
                                    return;
                                }
                            }
                            if (value[2][clave][2] === "minimo") {
                                if (value[2][clave][0] > value[2][clave][3](filterData[clave.substring(clave.length - 2, 0)])) {
                                    return;
                                }
                            }
                        }
                    }
                }
                return filterData
            })

            commit(data.dataFilterSet, newArrayFilter)
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    setStateManagmentData: ({ commit, state }, booleanIsOpen) => {
        commit('SET_IS_OPEN_MANAGMENT_DATA', booleanIsOpen)
    },
    async someFieldEmpty({ dispatch }, { fields, cbError }) {
        let arrayValuesFields = fields
        let isEmptySome = false

        if (typeof fields === "object" && !Array.isArray(fields)) {
            arrayValuesFields = Object.values(fields)
        }

        arrayValuesFields.forEach(field => {
            if (field === "" || String(field).trim() === '') {
                isEmptySome = true
            }
        })

        if (isEmptySome) {
            cbError ? cbError() : dispatch("activeMessageError", 'Por favor rellena los campos para crear una nueva caja')
        }

        return isEmptySome
    },
    async excessLimitCharacters({ dispatch }, { fields, limit, cbError }) {
        let arrayValuesFields = fields
        let isExcessSome = false

        if (typeof fields === "object" && !Array.isArray(fields)) {
            arrayValuesFields = Object.values(fields)
        }

        arrayValuesFields.forEach(field => {
            if (typeof field === "string" && field.length > limit) {
                isExcessSome = true
            }
        })

        if (isExcessSome) {
            cbError ? cbError() : dispatch("activeMessageError", "Nombre caja no puede exceder los 30 caracteres")
        }

        return isExcessSome
    },
    async setEventSubmit({ commit }, value) {
        const bul = value
        commit('SET_EVENT_SUBMIT', bul)
    },
    async changeErrorAnInputRequired({ commit }, value) {
        commit('SET_ERROR_INPUT_REQUIRED', value)
    },
    headerLoading: async ({ state, dispatch, commit }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let userHeader = await axios.get(`/information/private/header`, {params: {}}, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            // Set profile globally
            commit('SET_HEADER_PROFILE', userHeader.data);

            return userHeader;
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getNotifications: async ({ state, dispatch, commit }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const notifications = await axios.get(`/information/private/getNotifications`, { params: {} }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (notifications.status === 200) {
                commit('SET_NOTIFICATIONS', notifications.data.notifications);

                return 'ok';
            } else {
                return null;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    sendNotification: async ({ state, dispatch, commit }, object) => {
        const stateData = state.notifications;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const notification = await axios.post(`/information/private/sendNotification`, {
                ...object,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (notification.status === 200) {
                // Update notifications from the user who has the active session to update, only if the notification is for that user.
                if (object.Id_usuario === object.UserActiveSession) {
                    stateData.push(notification.data.notification)

                    commit('SET_NOTIFICATIONS', stateData);
                }

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    updateStatusNotification: async ({ state, dispatch, commit }, object) => {
        const stateData = state.notifications;

        try {
            if (object.Leido !== object.status) {
                // Start loader
                commit('SET_LOADER', true);
                
                const notification = await axios.post(`/information/private/updateStatusNotification`, {
                    ...object,
                })


                // Stop Loader
                commit('SET_LOADER', false);
    
                if (notification.status === 200) {
                    stateData.forEach((data, index) => {
                        if (data.Id_alertas === notification.data.data[0].Id_alertas) {
                            Object.assign(stateData[index], notification.data.data[0])
                        }
                    })
    
                    commit('SET_NOTIFICATIONS', stateData);
    
                    return 'ok';
                }
            } else {
                return;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getUsers: async ({ state, dispatch, commit }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const users = await axios.get(`/information/private/getUsers`, { params: {} }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (users.status === 200) {
                commit('SET_USERS', users.data.users);

                return 'ok';
            } else {
                return null;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getCurrenciesExchange: async ({ state, dispatch, commit }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const currencies = await axios.get(`/information/management/getCurrenciesExchange`, {
                params: {}
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (currencies.status === 200) {
                commit('SET_CURRENCIES', currencies.data.currencies);
                commit('SET_CURRENCIES_FILTROS', currencies.data.currencies);
                commit('SET_FORMATED_CURRENCIES', currencies.data.formatted)

                return 'ok';
            } else {
                return null;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getCurrenciesTime: async ({ state, dispatch, commit }, data) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const currencies = await axios.get(`/information/private/management/getCurrencieTime`, {
                params: {...data}
            }, {headers: { 'Content-Type': 'application/json' }});

            // Stop Loader
            commit('SET_LOADER', false);

            if (currencies.status === 200) {
                return currencies?.data?.currencies;
            } else {
                return null;
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    shiftCurrenciesGestion: async ({ commit, dispatch, state }, payload) => {
        const stateData = state.currencies;
        const stateDataFormat = state.currencyFormat

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newManagement = await axios.post(`/information/private/management/shiftCurrenciesGestion`, {
                ...payload,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newManagement.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Moneda_codigo === payload.data.Moneda_codigo) {
                        stateDataFormat[stateData[index].Id_conversion] = {...stateData[index],ConversionesFeatures:[newManagement.data.currency]}
                        stateData[index] = {...stateData[index],ConversionesFeatures:[newManagement.data.currency]}
                    }
                })

                dispatch('activeMessageCorrect', newManagement.data.message)
                commit('SET_CURRENCIES', stateData);
                commit('SET_CURRENCIES_FILTROS', stateData);
                commit('SET_FORMATED_CURRENCIES', stateDataFormat)

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    updateCurrencyGestion: async ({ commit, dispatch, state }, payload) => {

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newManagement = await axios.post(`/information/private/management/updateCurrencyGestion`, {
                ...payload,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newManagement.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Moneda === newManagement.data.currency.Moneda_codigo) {
                        Object.assign(stateData[index], newManagement.data.currency)
                    }
                })

                dispatch('activeMessageCorrect', newManagement.data.message)
                commit('SET_CURRENCIES', stateData);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    updateCurrency: async ({ commit, dispatch, state }, item) => {
        const stateData = state.gestiones;

        try {
            // Start loader
            commit('SET_LOADER', true);

            const newManagement = await axios.post(`/information/private/management/updateCurrency`, {
                Moneda: item,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newManagement.status === 200) {

                stateData.forEach((data, index) => {
                    if (data.Id_gestion === newManagement.data.data[0].Id_gestion) {
                        Object.assign(stateData[index], newManagement.data.data[0])
                    }
                })

                commit('SET_GESTIONES', stateData);
                commit('SET_MANAGEMENT_SELECTED', newManagement.data.data[0]);
                commit('SET_CURRENCY_SELECTED', newManagement.data.currency);

                return 'ok';
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    requestData: async ({ commit, state, dispatch }, data,bul=true) => {

        try {
            // Start loader
            if(!bul){commit('SET_LOADER', true)}

            const response = await axios.get(`/information/private/management/getData`, {
                params: {
                    data
                }
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            if(!bul){commit('SET_LOADER', false)}

            if (response.status === 200) {
                return response.data.allData
            }
        } catch (error) {
            // Stop Loader
            if(!bul){commit('SET_LOADER', false)}

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    searchInputManagementData: async ({ commit, state, dispatch }, obj) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const data = await axios.get(`/information/private/management/searchInputManagementData`, {
                params: {
                    textSearch: (obj) ? obj.textSearch : '',
                    subData: (obj) ? obj.subData : ''
                }
            }, {
                headers: { 'Content-Type': 'application/json' }
            });

            // Stop Loader
            commit('SET_LOADER', false);

            if (data.status === 200) {
                return data
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    updateAmountWithCurrency: async ({ commit, state, dispatch }, obj) => {
        const {array, property, currency} = obj;

        let newArray = []
        let tasaSelected = state.currencySelected?.ConversionesFeatures?.length > 0 
            ? state.currencySelected?.ConversionesFeatures[0]?.tasa
            : state.currencySelected?.Tasa

        const caseCurrency = (item,e) => {
            return (Number((item.currency || currency)) === Number(state.currencySelected.Id_conversion)) 
                ? (Number(item[e]) * Number(item.tasa)) 
                : Number(item[e]) * Number(tasaSelected)
        }

        for(let i = 0; i < (array || []).length; i++){
            if(typeof property !== 'string'){
                newArray[i] = {
                    ...array[i],
                    ... Object.fromEntries(property.map(e => {
                        return [e,caseCurrency(array[i], e)]
                    }))
                }
            }else{
                newArray[i] = {
                    ...array[i],
                    [property]: caseCurrency(array[i], property),
                }
            } 
        }

        return newArray
    },

    updateAmountWithCurrencyOne: async ({ commit, state, dispatch }, obj) => {
        const {mount, currencyOperationT, currencyOperationI} = obj;

        let tasaSelected = state.currencySelected?.ConversionesFeatures?.length > 0 
            ? state.currencySelected?.ConversionesFeatures[0]?.tasa
            : state.currencySelected?.Tasa

        return Number(currencyOperationI) === Number(state.currencySelected.Id_conversion) 
            ? Number(mount) * Number(currencyOperationT)
            : Number(mount) * Number(tasaSelected)
    }
}